import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { ExcelCopySource } from 'app/model/pipeline/copysource/excel.source';
import { commonCopySourceAdapts, CopySourceAdapter } from './copysource.adapter';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ExcelCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*'
    }
})
export class ExcelCopySourceAdapter extends CopySourceAdapter<ExcelCopySource, Model.ExcelSource> {
    protected override async _toResource(copySource: ExcelCopySource): Promise<Model.ExcelSource> {
        const result: Model.ExcelSource = this.getCommonCopySourceProperties(
            copySource,
            adfModelTypeMap.excel.copySourceType
        );
        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        return result;
    }

    protected override async _toModel(source: Model.ExcelSource, copyActivity: CopyActivity): Promise<ExcelCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            ExcelCopySource.MODEL,
            source,
            copyActivity
        ) as ExcelCopySource;
        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        return result;
    }
}
